import { useEffect, useState } from "react";
import Layout from "layouts/layout";
import { TabSelector } from "components/global/tabselector";
import { useLocalStorage, useDialogHook } from "utils/customhooks";
import LineVerticalSVG from "assets/svg/line-vertical";
import { BiCheck } from "react-icons/bi";
import Button from "components/button/button";
import {
  CoverDefaultPlaceholder,
  ProfileDefaultPlaceholder,
} from "constants/images";
import CropThumbnailModal from "components/profile/milestones/crop-thumbnail";
import CropCoverModal from "components/profile/milestones/crop-cover";
import SocialMediaForm from "components/account/forms/social-media-form";
// import MetadataForm from "components/account/forms/metadata-form";
import ProfileSettingsForm from "components/account/forms/profile-settings-form";
import ImagesForm from "components/account/forms/images-form";
import update from "immutability-helper";
import { useParams, useHistory } from "react-router-dom";
import { urlSerializer, randomExtension } from "utils/utils";
import userActions from "redux/modules/user/actions";
import { connect, useDispatch } from "react-redux";
import _ from "lodash";
import toast from "react-hot-toast";
import { UPDATE_PROFILE } from "redux/modules/user/types";
import LoadingIndicator from "assets/svg/loading-indicator";
import { social } from "utils/constant";
import EditCoverPhoto from "components/settings/component/EditCoverPhoto";

const SetupProfile = ({ userData, setUserData }) => {
  const { http, localstorage } = global.services;
  const { profileId, username } = useParams();

  const history = useHistory();
  const dispatch = useDispatch();
  // const [selectedTab, setSelectedTab] = useLocalStorage(1,2,3,4);
  const [selectedTab, setSelectedTab] = useState(1);

  const extension = randomExtension();
  const [previewProfile, setPreviewProfile] = useState(
    ProfileDefaultPlaceholder
  );
  const [cover, setCover] = useState(CoverDefaultPlaceholder);
  const cropProfile = useDialogHook(CropThumbnailModal);
  const cropCover = useDialogHook(CropCoverModal);
  
  const editCover = useDialogHook(EditCoverPhoto);
  const [keyword, setKeyword] = useState([]);
  const [socials, setSocials] = useState([{ social: "", link: "", media_type: "social", }]);
  const [websites, setWebsites] = useState([
    { social: "", link: "", media_type: "website", label: "" },
  ]);
  const [profile,setProfile] = useState({});
  
    const [albumCover,setAlbuCover] = useState([]);

  const [state, setState] = useState({
    profile_image_file: null,
    cover_image_file: null,
    username: null,
    other_name: null,
    condition: true,
    loading: false,
    validationErrors: null,
    adultContent: false,
    featured: true,
    showNotifications: true,
    profile_name:null,
    metadata: {},
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setState((prev) => ({
      ...prev,
      [name]: value,
      validationErrors: { ...state.validationErrors, [name]: null },
    }));
  };

const checkIconLink = (link) => {
    let tempSocial = [...social];
    let setType = link.replace(/.+\/\/|www.|\..+/g, "").toLowerCase(); //get domain name and set into type
    return tempSocial
      .map((obj) =>
        link.toLowerCase().includes(obj.site) ? obj.value : setType
      )
      .filter((value) => value !== setType);
  };

  const onTypeLinkSocial = (e, index,media_type) => {
    // let payload = _.clone(socials);
    // let result = update(payload, {
    //   [index]: {
    //     link: { $set: e.target.value },
    //   },
    // }); //remove
    // setSocials(result);

        let setType = e.target.value.replace(/.+\/\/|www.|\..+/g, "").toLowerCase();
        let socialVal = checkIconLink(e.target.value)[0] || setType;
        let payload = [];
        if (media_type === "social") {
          payload = _.clone(socials);
        } else if (media_type === "website") {
          payload = _.clone(websites);
        }
    
        let result = update(payload, {
          [index]: {
            link: { $set: e.target.value }, 
            social: { $set: socialVal },
    
          },
        }); //remove
    
        if (media_type === "social") {
          setSocials(result);
        } else if (media_type === "website") {
          setWebsites(result);
        }
  };

  const onSelectSocial = (e, index) => {
    let value = e ? e.value : "";
    let payload = _.clone(socials);
    let result = update(payload, {
      [index]: {
        social: { $set: value },
      },
    }); //remove
    setSocials(result);
  };

  const onRemoveSocials = (index,media_type) => {
    // let payload = _.clone(socials);
    // let result = update(payload, { $splice: [[index, 1]] }); //remove
    // setSocials(result);
    if (media_type === "social") {
          let payload = _.clone(socials);
          let result = update(payload, { $splice: [[index, 1]] }); //remove 
          setSocials(result);
        } else if (media_type === "website") {
          let payload = _.clone(websites);
          let result = update(payload, { $splice: [[index, 1]] }); //remove
          setWebsites(result);
        }
    
  };

   const removeSocialErrorByIndex = (errorObj, indexToRemove,options) => {
        if(!_.isEmpty(errorObj)){ 
          const socialKeys = Object.keys(errorObj).filter(key => key.startsWith('social'));
          
          if(!_.isEmpty(socialKeys)){  
            const keyToRemove = socialKeys[indexToRemove];
            let { [keyToRemove]: _, ...remainingErrors } = errorObj;
            const newErrors = Object.keys(remainingErrors).reduce((acc, key) => {
              const match = key.split(".");
              const index = parseInt(match[1], 10); 
              if (key.match(/^social\.(\d+)\.type$/) && index !== indexToRemove) {
                if(index > indexToRemove){
                  let newIndex = index - 1;
                  const newKey = `social.${newIndex}.${match[2]}`;
                  acc[newKey] = errorObj[key];
                }else{
                  const newKey = `social.${index}.${match[2]}`;
                  acc[newKey] = errorObj[key];
                }
              }
              return acc;
            }, {});
    
            return newErrors;
          }
         
        }
        
    };

  const onAddSocials = (media_type) => {
    // let payload = _.clone(socials);
    // payload.push({ social: "", link: "" });
    // setSocials(payload);

    if (media_type === "social") {
          let payload = _.clone(socials);
          payload.push({ social: "", link: "", media_type: "social", });
          setSocials(payload);
        } else if (media_type === "website") {
          let payload = _.clone(websites);
          payload.push({ social: "", link: "", media_type: "website", label: "" });
          setWebsites(payload);
        }
  };

  const handleInputObjectChange = (e, object) => {
    const { name, value } = e.target;

    setState((prev) => ({
      ...prev,
      [object]: { ...prev[object], [name]: value },
    }));
  };

  const onChangeKeywords = (e) => {
    let _value = e.map((v) => v.value);
    setKeyword((prev) => _value);
  };

  const onUploadImage = async (e, type = "profile") => {
    const file = type === "cover" ? e[0] : e.target.files[0];
    const reader = new FileReader();

    reader.addEventListener(
      "load",
      function () {
        // convert image file to base64 string
        const image = reader.result?.toString() || "";
        let title =
          type === "profile" ? "Crop Profile Picture" : "Crop Cover Photo";
        const Iprops = {
          image: image,
          type: file.type,
          returnType: "file",
          title: title,
        };
        if (image) {
          if (type === "profile") {
            cropProfile(Iprops, (result) => {
              if (result) {
                const { imageFile, preview } = result;
                setState((prev) => ({
                  ...prev,
                  profile_image_file: imageFile,
                }));
                setPreviewProfile(preview);
              }
            });
          } else {
            Iprops.updateCoverPhoto = updateCoverPhoto;
            cropCover(Iprops, (result) => {
              if (result) {
                const { imageFile, preview } = result;
                setState((prev) => ({ ...prev, cover_image_file: imageFile }));
                setCover(preview);
              }
            });
          }
        }
      },
      false
    );

    if (file) {
      reader.readAsDataURL(file);
    }
  };

  const fetchProfile = async () => {
    try {
      const url = urlSerializer("public/user-profiles/get-profile", {
        id: profileId,
        username: username.split("-")[0],
      });
      const { data: response } = await http.get(url);

      let filter = {};
      if (typeof response.milestone_filter === "string") {
        filter = JSON.parse(response.milestone_filter);
      } else if (typeof response.milestone_filter === "object") {
        filter = response.milestone_filter;
      }

      if (
        !_.isEmpty(response.metadata) &&
        !_.isEmpty(response.metadata.keywords)
      ) {
        setKeyword((prev) => response.metadata.keywords);
      }

      if (response.profile_image_url)
        setPreviewProfile(response.profile_image_url);

      if (response.cover_image_url) setCover(response.cover_image_url);

      if (!_.isEmpty(response)) {
        setProfile(response)
        setState((prev) => ({
          ...prev,
          id: response.id,
          username: userData.user.username,
          other_name: response.other_name,
          profile_name:response.profile_name,
          gender: response.gender,
          pronoun: response.pronoun,
          address: response.address,
          occupations: response.occupations ? response.occupations : [],
          adultContent: response.show_adult,
          featured: response.show_featured,
          showNotifications: response.show_notifications,
          metadata: response.metadata ? response.metadata : {},
          profileTypes: response.profile_type
            ? response.profile_type.type
            : null,
          profileStyle: response.profile_type
            ? response.profile_type.style
            : null,
          job_role: filter?.job_role || null,
          category: filter?.category || null,
          sort: filter?.sort || null,
        }));
      }
    } catch (err) {
      console.log("fetchProfile", err);
    }
  };

  const getSocialMedia = async () => {
    let socialMedia = [];

    try {
      const { data } = await http.get("public/social-medias", {
        user_profile_id: profileId,
      });
      if (data.length > 0) {
        data.forEach((sm) => {
          socialMedia.push({ social: sm.type, link: sm.link });
        });
        // console.log("socialMedia", socialMedia);
        setSocials(socialMedia);
      }
    } catch (err) {
      console.log("getSocialMedia", err);
    }
  };

  const next = () => {
    let error = {};

    if (selectedTab ===1) {
      // socials.forEach((s, i) => {
      //   if (!s.social)
      //     error[`social.${i}.type`] = "The social field is required";
      //   if (!s.link) error[`social.${i}.link`] = "The link field is required";
      // });

      // if (!state.profileTypes) {
      //   error["profileTypes"] = "The profile type field is required";
      // }
      // if (!state.profileStyle) {
      //   error[`profileStyle`] = "The profile style field is required";
      // }

      if (!error.social) {
        setSelectedTab(2);
      }
    } 
    // else if (selectedTab === 1) {
    //   error.metadata = {};
    //   if (!state.metadata.title) {
    //     error.metadata.title = "The title field is required";
    //   }
    //   if (!state.metadata.description) {
    //     error.metadata.description = "The description field is required";
    //   }
    //   if (!keyword.length) {
    //     error.metadata.keywords = "The keywords field is required";
    //   }

    //   if (
    //     state.metadata.title &&
    //     state.metadata.description &&
    //     keyword.length > 0
    //   ) {
    //     setSelectedTab(3);
    //   }
    // } 
    else if (selectedTab === 1) {
      // if (!state.job_role) {
      //   error.job_role = "The job role field is required";
      // }
      // if (!state.category) {
      //   error.category = "The category field is required";
      // }
      // if (!state.sort) {
      //   error.sort = "The sort field is required";
      // }

      // if (state.job_role && state.category) {
        setSelectedTab(2);
      // }
    }

    let validation = !_.isEmpty(error) ? error : null;

    setState((prev) => ({
      ...prev,
      validationErrors: validation,
    }));
  };

  const skip = () => {
    // if (selectedTab === 1) {
    //   const { profileTypes, profileStyle, ...otherState } = state;
    //   setState((prev) => ({
    //     ...otherState,
    //     validationErrors: null,
    //   }));
    //   setSocials([{ social: "", link: "" }]);
    //   setSelectedTab(2);
    // } 
    // else if (selectedTab === 1) {
    //   setState((prev) => ({
    //     ...prev,
    //     metadata: {},
    //     validationErrors: null,
    //   }));
    //   setSelectedTab(3);
    // } 
    if (selectedTab === 1) {
      setSocials([{ social: "", link: "" }]);
      setSelectedTab(2);
    }
  };

  const back = () => {
    // if (selectedTab === 1) {
    //   setSelectedTab(0);
    // } else 
    if (selectedTab === 2) {
      setSelectedTab(1);
    }
    //  else if (selectedTab === 3) {
    //   setSelectedTab(2);
    // }
  };

  const done = async (e) => {
    e.preventDefault();
    setState((prev) => ({ ...prev, loading: true }));

    let payload = new FormData();
    let params = _.clone(state);

    // if (keyword.length > 0)
    //   params.metadata = {
    //     ...state.metadata,
    //     keywords: keyword,
    //   };

    Object.keys(params).forEach((key) => {
      if (key === "preview_covers" || key === "cover_image_file") return;

      if (key === 1) params[key] = JSON.stringify(params[key]);

      if (
        (key === "profile_image_file") &&
        params[key]
      )
        payload.append(key, params[key]);

      if (typeof params[key] === "boolean" || !_.isEmpty(params[key])) {
        payload.append(key, params[key]);
      }
    });

    // socials.forEach((social, index) => {
    //   if (social.social || social.link) {
    //     payload.append(`social[${index}][type]`, social.social);
    //     payload.append(`social[${index}][link]`, social.link);
    //   }
    // });

    let mergeSocialWebsite = [...socials, ...websites];
    mergeSocialWebsite = removeDuplicateSocial(mergeSocialWebsite); 
    mergeSocialWebsite.forEach((social, index) => {
      if (social.social || social.link) {
        payload.append(`social[${index}][type]`, social.social);
        payload.append(`social[${index}][link]`, social.link);
        payload.append(`social[${index}][media_type]`, social.media_type);
        payload.append(`social[${index}][label]`, social.label || "");
      }
    });
    
    payload.append("user_id", userData.user.id);
    payload.append(`profileId`, profileId);
    payload.append(`showAdultContent`, state.adultContent);
    payload.append(`showNotifications`, state.showNotifications);
    // payload.append("_method", "PUT");

    try {
      const { data, status } = await http.post(
        `public/profiles/update-profile-images`,
        payload,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (status === 200) {
        toast.success(data.message);
        const newUserData = {
          ...userData,
          profile: data.profile,
          profiles:[...[userData.profiles],...[data.profile]]
        };

        localstorage.set("user_data", JSON.stringify(newUserData));
        setState((prev) => ({
          ...prev,
          profile_image_file: null,
          cover_image_file: null,
        }));
        setUserData(newUserData);
        dispatch({
          type: UPDATE_PROFILE,
          payload: data.profile,
        });

        setSelectedTab(1);
        history.push(
          `/${userData.user.username}-${extension}/profile/${data.profile.id}`,
          {
            switchProfile: true,
          }
        );
      }
    } catch (error) {
      if (error.status === 422)
        return setState((prev) => ({
          ...prev,
          validationErrors: error.data?.errors,
        }));

      toast.error(
        error.status === 401
          ? "Invalid Credentials"
          : error?.data?.message || "It appears that something went wrong"
      );
      console.log(error)
    } finally {
      setState((prev) => ({ ...prev, loading: false }));
    }
  };

  const removeDuplicateSocial = (socailWebsite) => {
    
    const uniqueData = socailWebsite.filter((item, index, self) =>
      index === self.findIndex((t) => t.link === item.link)
    );
    return uniqueData;
    
  }

  const getCoverPhotos = async () => {
    try {
      const { data } = await http.get("profiles/cover/photos", {
        user_profile_id: profileId,
      });
      console.log(data);
      if(data.length > 0){
        setAlbuCover(data); 
        setState(prev => {
          return{
            ...prev,
            preview_covers:data
          }
        });
      }
    } catch (err) {
      console.log("getCoverPhotos", err);
    }
  };

  const editCoverHandler = (newUpload=[])=>{
    let preview_covers = newUpload.length > 0 ? 
      [...state.preview_covers,...newUpload] : 
      state.preview_covers;
    editCover(
      {
        userData,
        profile,
        onUploadImage:(e)=>{onUploadImage(e, "cover")},
        preview_covers:preview_covers,
        cover,
        setCover:(preview)=>{setCover(preview.webp_url || preview.url); 
        setState(prev=>{return {...prev, status:preview.status, media_id:preview.media_id}});},
        updateCoverPhoto
      },
      (callback) => {
        if (callback) {
          // getPhotoVideos();
        }
      }
    );
    console.log("List of Covers");
    console.log(state.preview_covers);
    console.log(state.list_covers);
  }

  const updateCoverPhoto = async (cropFile=null, selectedCover=null)=>{
      try {
        let payload = new FormData();
        payload.append("cover_image_file", cropFile);
        payload.append("user_id", userData.user.id);
        payload.append("user_profile_id", profileId);
        payload.append("profile_image_id", profileId);
        payload.append("cover_photo_id", selectedCover?.media_id);
        payload.append("cover_photo_status", selectedCover?.status);
        payload.append("_method", "PUT");
        
        const { data, status } = await http.post(
          `profiles/cover/${profileId}`,
          payload,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
  
        if (status === 200) {
          toast.success(data.message);
          let addNewCover = [];
          if(data.new_cover){
            let media_id = data?.media?.id;
            let url = data?.media?.url;
            addNewCover = [...state.preview_covers, {media_id:media_id, url:url }]
          }else{
            addNewCover = [...state.preview_covers]
          }
          setState((prev) => ({
            ...prev,
            cover_image_file: null,
            validationErrors: null,
            preview_covers:addNewCover,
            // this line will prevent clearing profile picture IF profile was changed and not saved yet
            ...(!(!!profile && !!state.profile_image_file) && {
              profile_image_file: null,
            })
          }));
          return true;
        }
      } catch (error) {
        if (error.status === 422) {
          toast.error('It appears that something went wrong');
          return setState((prev) => ({
            ...prev,
            validationErrors: error.data?.errors,
          }));
        }
  
        toast.error(
          error.status === 401
            ? "Invalid Credentials"
            : error?.data?.message || "It appears that something went wrong"
        );
        console.log(error)
      }
    }

  useEffect(() => {
    if (profileId) {
      fetchProfile();
      getSocialMedia();
      getCoverPhotos()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profileId]);

  return (
    <Layout title="Profile" setUserData={setUserData}>
      <div className="auth-page-wrapper pb-8.5">
        <div className="w-full bg-white px-7.5 1md:px-24.5 pt-9 rounded-md">
          <h1 className="text-3xl text-lightBlack tracking-tighter font-bold">
            Finish setting up your Profile
          </h1>
          <p>
            Congratulations! You've created{" "}
            <span className="font-bold">{state.profile_name || state.other_name }</span>. Now add more
            details to help people connect with you.
          </p>
          <div className="flex justify-center flex-wrap md:flex-nowrap md:justify-center items-center">
            {/* <TabSelector
              disabled={true}
              isActive={selectedTab === 1}
              gap="3sm:mr-10"
              colorType={selectedTab > 0 ? "black" : "default"}
              paddingY="py-7.5"
              onClick={() => setSelectedTab(1)}>
              <div className="w-full flex justify-center items-center">
                {selectedTab > 1 ? (
                  <div className="w-6 h-6 rounded-full bg-lightGreen flex justify-center items-center text-sm mr-3">
                    <BiCheck className="text-white text-base" />
                  </div>
                ) : (
                  <div className="w-6 h-6 rounded-full border-2 flex justify-center items-center text-sm mr-3">
                    1
                  </div>
                )}
                Profile Settings
              </div>
            </TabSelector> */}
            
            {/* <TabSelector
              disabled={true}
              isActive={selectedTab === 1}
              gap="3sm:mx-10"
              colorType={selectedTab > 1 ? "black" : "default"}
              paddingY="py-7.5"
              onClick={() => setSelectedTab(1)}>
              <div className="w-full flex justify-center items-center">
                {selectedTab > 1 ? (
                  <div className="w-6 h-6 rounded-full bg-lightGreen flex justify-center items-center text-sm mr-3">
                    <BiCheck className="text-white text-base" />
                  </div>
                ) : (
                  <div className="w-6 h-6 rounded-full border-2 flex justify-center items-center text-sm mr-3">
                    2
                  </div>
                )}
                Metadata
              </div>
            </TabSelector> */}
             
            <TabSelector
              // disabled={true}
              isActive={selectedTab === 1}
              gap="3sm:mx-10"
              colorType={selectedTab > 1 ? "black" : "default"}
              paddingY="py-7.5"
              onClick={() => setSelectedTab(1)}>
              <div className="w-full flex justify-center items-center">
                {selectedTab > 3 ? (
                  <div className="w-6 h-6 rounded-full bg-lightGreen flex justify-center items-center text-sm mr-3">
                    <BiCheck className="text-white text-base" />
                  </div>
                ) : (
                  <div className="w-6 h-6 rounded-full border-2 flex justify-center items-center text-sm mr-3">
                    1
                  </div>
                )}
                Social Media
              </div>
            </TabSelector>
            <div className="hidden 3sm:block">
              <LineVerticalSVG />
            </div>
            <TabSelector
              // disabled={true}
              isActive={selectedTab === 2}
              gap="3sm:ml-10"
              colorType={selectedTab > 2 ? "black" : "default"}
              paddingY="py-7.5"
              onClick={() => setSelectedTab(2)}>
              <div className="w-full flex justify-center items-center">
                <div className="w-6 h-6 rounded-full border-2 flex justify-center items-center text-sm mr-3">
                  2
                </div>
                Images
              </div>
            </TabSelector>
          </div>
        </div>

        <div className="w-full bg-white rounded-md">
          <div className="px-7.5 1md:px-24.5 pt-2 mt-4.5">
            {/* {selectedTab === 1 && (
               <ProfileSettingsForm
               {...{
                 state,
                 setState,
                 userData,
                 handleInputChange,
               }}
             />
              
            )} */}
            {/* {selectedTab === 1 && (
              <MetadataForm
                {...{
                  state,
                  keyword,
                  handleInputObjectChange,
                  onChangeKeywords,
                }}
              />
            )} */}
            {selectedTab === 1 && (
              <SocialMediaForm
              {...{
                state,
                socials,
                onAddSocials,
                onTypeLinkSocial,
                onSelectSocial,
                onRemoveSocials,
                handleInputChange,
                websites,
                setWebsites
              }}
            />
            )}
            {selectedTab === 2 && (
              <ImagesForm
                {...{
                  previewProfile,
                  cover,
                  onUploadImage,
                  editCoverHandler
                }}
              />
            )}
          </div>
          {/* footer */}
          <div className="py-5.5 px-7.5 1md:px-24.5 border-t-2 border-gray mt-8">
            <div className="w-full flex justify-between">
              <div>
                {selectedTab < 2 && (
                  <Button
                    buttonName="Skip this step"
                    buttonTextClass="text-xs text-lightBlack font-semibold"
                    buttonRadius="6px"
                    buttonClass="relative py-4 px-7.5 bg-thBg mr-3.5"
                    onClick={skip}
                  />
                )}
              </div>
              <div>
                
                {selectedTab === 2 ? (
                  <>
                    <Button
                    disabled={state.loading}
                    buttonName="Back"
                    buttonTextClass="text-xs text-lightBlack font-semibold"
                    buttonRadius="6px"
                    buttonClass="relative py-4 px-15 bg-thBg mr-3.5"
                    onClick={back}
                  />
                  <Button
                    disabled={state.loading}
                    buttonName="Done"
                    buttonTextClass="text-xs text-white font-semibold flex flex-row items-center gap-2"
                    buttonRadius="6px"
                    buttonClass="relative py-4 px-15 bg-primary"
                    onClick={done}
                    icon={
                      state.loading ? (
                        <LoadingIndicator className="text-white w-4 h-4" />
                      ) : null
                    }
                  />
                  </>
                ) : (
                  <Button
                    buttonName="Next"
                    buttonTextClass="text-xs text-white font-semibold flex flex-row items-center gap-2"
                    buttonRadius="6px"
                    buttonClass="relative py-4 px-15 bg-primary"
                    onClick={next}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

const mapStateToProps = (state) => {
  return {
    userData: state.user.userData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setUserData: (params) => {
      dispatch(userActions.setUserData(params));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SetupProfile);
